import * as React from "react";

function StarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.762 3.732a.25.25 0 01.476 0l1.726 5.314a.25.25 0 00.238.173h5.588a.25.25 0 01.147.452l-4.52 3.285a.25.25 0 00-.091.28l1.726 5.313a.25.25 0 01-.384.28l-4.521-3.285a.25.25 0 00-.294 0l-4.52 3.285a.25.25 0 01-.385-.28l1.726-5.314a.25.25 0 00-.09-.28L4.063 9.672a.25.25 0 01.147-.452h5.588a.25.25 0 00.238-.173l1.726-5.314z"
  }));
}

export default StarIcon;